import React from 'react';
import PropTypes from 'prop-types';
// Models
import { listFeatures } from 'models/cpm/slug';
// HOCs
import wrapListFilters from 'hocs/WrapListFilters';
// Custom
import {
  listFeatureSearchFieldShape,
  listFilterShape,
} from 'constants/PropTypesShapes';
// Components
import FiltersCardTemplate from 'components/templates/FiltersCardTemplate';
import BaseListFilter from 'components/filters/BaseListFilter';
import TextFieldFilter from 'components/filters/TextFieldFilter';

const SlugFilters = ({
  disabled,
  advanced,
  nbFiltersApplied,
  searchFields,
  field,
  filters,
  isFieldDisplayable,
  onFieldChange,
  onFilterFieldChange,
  onReinit,
  onSwitch,
}) => {
  const { domain, slug } = filters;

  return (
    <div className="px-3 mb-3">
      <FiltersCardTemplate
        disabled={disabled}
        advanced={advanced}
        nbFiltersApplied={nbFiltersApplied}
        onReinit={onReinit}
        onSwitch={onSwitch}
      >
        <React.Fragment>
          {!advanced && (
            <div className="col-12 col-md-4 col-xl-3">
              <BaseListFilter
                field={field}
                searchFields={searchFields}
                onChange={onFieldChange}
              />
            </div>
          )}
          {/* ----- DOMAIN ----- */}
          {isFieldDisplayable('domain') && (
            <div className="col-12 col-md-4 col-xl-3">
              <TextFieldFilter
                label="field.domain"
                value={domain.value}
                onChange={(value) => onFilterFieldChange('domain', value)}
              />
            </div>
          )}
          {/* ----- SLUG ----- */}
          {isFieldDisplayable('slug') && (
            <div className="col-12 col-md-4 col-xl-3">
              <TextFieldFilter
                label="field.slug"
                value={slug.value}
                onChange={(value) => onFilterFieldChange('slug', value)}
              />
            </div>
          )}
        </React.Fragment>
      </FiltersCardTemplate>
    </div>
  );
};

SlugFilters.propTypes = {
  // From HOC
  disabled: PropTypes.bool.isRequired,
  advanced: PropTypes.bool.isRequired,
  nbFiltersApplied: PropTypes.number.isRequired,
  searchFields: PropTypes.arrayOf(listFeatureSearchFieldShape).isRequired,
  field: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    domain: listFilterShape,
    slug: listFilterShape,
    type: listFilterShape,
  }).isRequired,
  isFieldDisplayable: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFilterFieldChange: PropTypes.func.isRequired,
  onReinit: PropTypes.func.isRequired,
  onSwitch: PropTypes.func.isRequired,
};

module.exports = wrapListFilters(listFeatures.searchFields)(SlugFilters);



// WEBPACK FOOTER //
// ./routes/cpm/routes/workspaces/assets/slug/SlugFilters.js